import { render, staticRenderFns } from "./ConsultForm.vue?vue&type=template&id=a4473d3e&"
import script from "./ConsultForm.vue?vue&type=script&lang=js&"
export * from "./ConsultForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports